import { render } from "./premiumCoursewareInfo.vue?vue&type=template&id=79a41920&scoped=true"
import script from "./premiumCoursewareInfo.vue?vue&type=script&lang=js"
export * from "./premiumCoursewareInfo.vue?vue&type=script&lang=js"

import "./premiumCoursewareInfo.vue?vue&type=style&index=0&id=79a41920&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a41920"]])

export default __exports__